var lastWidth = lastHeight = cssWidth = 0;
var scrollTop, lastScrollTop, scrollbarWidth, scrollDirection;
var announcementHeight, headerHeight;
var CollectionPagerMoreCommandUrl, CollectionPagerMoreCommandNode;

$(document).ready(function()
{
	// SCROLL WIDTH
	scrollbarWidth = GetscrollbarWidth();

	// Ratio
	$(".js-ratio").each(function(i){
		var r = String($(this).attr("data-ratio")).split(":");
		$(this).attr("data-ratio", (r[1]/r[0]));

		if ($(this).attr("data-ratio-mobile")) {
			r = String($(this).attr("data-ratio-mobile")).split(":");
			$(this).attr("data-ratio-mobile", (r[1]/r[0]));
		} else {
			if ($(this).attr("data-ratio-tablet")) $(this).attr("data-ratio-mobile", $(this).attr("data-ratio-tablet"));
			else $(this).attr("data-ratio-mobile", $(this).attr("data-ratio"));
		}

		if ($(this).attr("data-ratio-tablet")) {
			r = String($(this).attr("data-ratio-tablet")).split(":");
			$(this).attr("data-ratio-tablet", (r[1]/r[0]));
		} else {
			$(this).attr("data-ratio-tablet", $(this).attr("data-ratio"));
		}
	});

	// Scroll to
	$(".js-scrollto2").click(function(e){
		e.preventDefault();
      	
      	var href = $(this).attr("href");
		var target = $(href);

		if (target.length > 0 || $(this).attr("data-pos")) {
          var decal = Number($(this).attr("data-decal") ? $(this).attr("data-decal") : 0);
          var pos = Number($(this).attr("data-pos") ? $(this).attr("data-pos") : $($(this).attr("href")).offset().top) - decal;
          $("html, body").animate({ scrollTop: pos}, 500, "easeInOutExpo");
        }
	});

    // HEADER QUICK LINKS
    $('#popover-collection-menu .Popover__ValueList').html($('.top-nav-collection').html());
  
  	// Collection Menu
    $('#open-popover-collection-menu').click(function(e){
      e.preventDefault();
      $('#popover-collection-menu').attr('aria-hidden', 'false');
      $('.PageOverlay').addClass('is-visible');
      $('html').addClass('no-scroll');
    });
  	$('.PageOverlay').click(function(e){
      if ($('#popover-collection-menu').attr('aria-hidden') == 'false') {
        e.preventDefault();
        $('#popover-collection-menu').attr('aria-hidden', 'true');
        $('.PageOverlay').removeClass('is-visible');
        $('html').removeClass('no-scroll');
      }
    });
  
  	// TAB SIZE GUIDE
  	$('a.goto-size-guide').click(function(e){
      e.preventDefault();
      
      $('#tab-n2 button').click();
      
      var pos = Number($('#tab-n2').offset().top) - 0;
      $("html, body").animate({ scrollTop: pos}, 500, "easeInOutExpo");
      
    });
  
  	// COLLECTION PAGER
  	/*function CollectionPagerMoreCommand() {
      $('#more a').click(function(e){
        e.preventDefault();

        CollectionPagerMoreCommandUrl = $(this).attr("href");
        
        CollectionPagerMoreCommandNode.find('a').addClass('hide');
        CollectionPagerMoreCommandNode.find('span').removeClass('hide');

        $.ajax({
          type: 'GET',
          url: CollectionPagerMoreCommandUrl,
          dataType: "html",
          success: function(data) {
            if ($(data).find("#more a").length > 0) {
              CollectionPagerMoreCommandUrl = $(data).find("#more a").attr('href');
              CollectionPagerMoreCommandNode.find('a').attr('href', $(data).find("#more a").attr('href'));
              CollectionPagerMoreCommandNode.find('a').removeClass('hide');
		      CollectionPagerMoreCommandNode.find('span').addClass('hide');
            } else {
              CollectionPagerMoreCommandNode.remove();
            }

            $(".ProductListWrapper").append($(data).find(".ProductList"));
            
            
          }
        });
      });
    }
  
  	CollectionPagerMoreCommandNode = $('#more');
  	CollectionPagerMoreCommand();*/
  
  	// PREORDER OPEN NEWSLETTER
    $('a.open-newsletter-popin').click(function(e){
      e.preventDefault();
      $('.NewsletterPopup').attr('aria-hidden', 'false');
    });
  
  	// ANIM HOMEPAGE
    $('.shopify-section--blocs-martinez .bloc-martinez.animated').each(function(i){
      var speed = Number($(this).data('anim-speed')) * 1000;
      
      setInterval(function(target){
        var speed = Number(target.data('anim-speed')) * 1000;
        var index = Number(target.data('anim-index'));
        var max = Number(target.data('anim-max'));
        
        target.find('.image.nb' + index).addClass('last');
        
        index++;
        if (index > max) index = 1;
        
        target.data('anim-index', index);
        
        target.find('.image.nb' + index).addClass('current');
        setTimeout(function(target){
          target.find('.image.last').removeClass('current last');
        }, (speed / 2), target);
        
      }, speed, $(this));
    });

    // READ ACCEPT
    /*$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      } else {
        //$('.read_accept_content').addClass('error');
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });*/

    // Announcement
    if ($('#shopify-section-announcement').length > 0)
      $('body').addClass('announcement-exist');

    // CARE GUIDE
    if ($('.page-care-guide .page-menu').length > 0) {
      $('.page-care-guide .page-menu a').click(function(e){
        e.preventDefault();
        
        $('.page-care-guide .page-menu a, .page-care-guide .page-content-item, .page-care-guide .bloc-image .sub').removeClass("on");

        $(this).addClass("on");
        $('.page-care-guide .page-content-item[data-index="' + $(this).data('index') + '"]').addClass("on");
        $('.page-care-guide .bloc-image .sub[data-index="' + $(this).data('index') + '"]').addClass("on");
      });

      $('.page-care-guide .page-menu a:eq(0)').click();
    }

    // Product picto slider
    if ($('.ProductItem__PictoSlider').length > 0) {
      $('.ProductItem__PictoSlider:eq(0)').closest('.ProductItem').addClass('anim-picto-slider');
      
      setTimeout(function(){
        $('.ProductItem__PictoSlider:eq(0)').addClass('open');
        setTimeout(function(){
          $('.ProductItem__PictoSlider:eq(0)').removeClass('open');
          $('.ProductItem__PictoSlider:eq(0)').closest('.ProductItem').removeClass('anim-picto-slider');
        }, 2000);
      }, 1000);      
    }

    // Collection filter
    $('#collection-filter-open-js').click(function(e){
      e.preventDefault();
      $('body').toggleClass('collection-filter-open');
    });

    // Debug filters URL
    console.log($('.CollectionFilters__ClearButton').length);
    if ($('.CollectionFilters__ClearButton').length > 0) {
      $("button.Popover__Value[data-value=manual]").click();
    }
	
	// RUN
	//InitKeys();
	//InitCookies();
	InitResize();
	InitScroll();
});



// KEYS
function InitKeys()
{
	$(document).keydown(function(e) {
		if (e.keyCode == 27) {
			
		}
	});
}



// COOKIES
function InitCookies()
{
	/*var testMessageCookie = readCookie('cookie-view');
	if (testMessageCookie == undefined) {
		createCookie('cookie-view', 1, 30);
	}*/
}



// RESIZE
function InitResize()
{
	$(window).resize(function(){ Resize(); });
	document.addEventListener("webkitfullscreenchange",function(){ Resize(); }, false);
	window.onorientationchange = function(){ var orientation = window.orientation; Resize(); }
	Resize();
	setTimeout(function(){ Resize(); }, 500);
}
function Resize()
{
	lastWidth = $(window).width();
	lastHeight = $(window).height();
	cssWidth = lastWidth + scrollbarWidth;
  
  	// NAV
	announcementHeight = $("#shopify-section-announcement").height();
    headerHeight = $(".shopify-section--header").height();

	// Ratio
	$(".js-ratio").each(function(i){
		if ((lastWidth + scrollbarWidth) < 768) $(this).height(Math.ceil($(this).width() * $(this).attr("data-ratio-mobile")));
		else if ((lastWidth + scrollbarWidth) < 1024) $(this).height(Math.ceil($(this).width() * $(this).attr("data-ratio-tablet")));
		else $(this).height(Math.ceil($(this).width() * $(this).attr("data-ratio")));
	});
  
	CheckLoadingVideos();
}



// SCROLL
function InitScroll()
{
	$(window).scroll(function(){
      scrollTop = $(window).scrollTop();

      /*if (scrollTop > lastScrollTop) scrollDirection = 1;
      else scrollDirection = -1;
      
      if (scrollDirection == 1) {
        if (scrollTop > (announcementHeight + headerHeight)) {
          $('.shopify-section--header').addClass('fixed');
          $('#main').addClass('decal');
          if (!$('.shopify-section--header').is('.anim')) {
            $('.shopify-section--header').addClass('anim').stop().animate({'top':-89}, 250, function(){
              $(this).removeClass('anim');
          	});
          }
        } else {
          $('.shopify-section--header').removeClass('fixed');
          $('#main').removeClass('decal');
          $('.shopify-section--header').stop().animate({'top':-89}, 0);
        }
        
        $('.CollectionToolbar--top').addClass('dir-bottom').removeClass('dir-top');
      } else {
        if (scrollTop < announcementHeight) {
          $('.shopify-section--header').removeClass('fixed');
          $('#main').removeClass('decal');
        } else {
          $('.shopify-section--header').addClass('fixed');
          $('#main').addClass('decal');
          if (!$('.shopify-section--header').is('.anim')) {
            $('.shopify-section--header').addClass('anim').stop().animate({'top':0}, 250, function(){
              $(this).removeClass('anim');
            });
          }
        }
        
        $('.CollectionToolbar--top').addClass('dir-top').removeClass('dir-bottom');
      }*/
      
      /*if (scrollTop > announcementHeight) {
        $('.shopify-section--header').addClass('fixed');
        $('#main').addClass('decal');
      } else {
        $('.shopify-section--header').removeClass('fixed');
        $('#main').removeClass('decal');
      }*/

      // FLICKITY
      const sliders = Array.from(document.querySelectorAll('.ProductList--carousel'));
      if (sliders) {
        sliders.forEach((slider) => {
          var flkty = Flickity.data(slider);
          flkty.resize();
        });
      }


  
	  CheckLoadingVideos();
      
      lastScrollTop = scrollTop;
	});
	$(window).scroll();
}

function CheckLoadingVideos() {
  $('.bloc-martinez .video').each(function(i){
    $(this).find("video").each(function(j){
      var yVideo1 = ($(this).offset().top - scrollTop - lastHeight);
      var yVideo2 = yVideo1 + $(this).height() + lastHeight;
      if (yVideo1 < 50 && yVideo2 > -50) {
        if ($(this).is(".toload") && $(this).is(":visible")) {
          $(this).removeClass("toload").attr("src", $(this).attr("data-src"));
        }
        if (!$(this).is(".toload") && !$(this).is(":visible")) {
          $(this).addClass("toload").attr("src", "");
        }
      }
    });
  });
}



// COOKIE
function createCookie(a,b,c){var d="";if(c){var e=new Date;e.setTime(e.getTime()+24*c*60*60*1e3),d="; expires="+e.toGMTString()}document.cookie=a+"="+b+d+"; path=/"}function readCookie(a){for(var b,c=a+"=",d=document.cookie.split(";"),e=0;e<d.length;e++){for(b=d[e];" "==b.charAt(0);)b=b.substring(1,b.length);if(0==b.indexOf(c))return b.substring(c.length,b.length)}return null}function eraseCookie(a){createCookie(a,"",-1)}

// EASE
jQuery.easing.jswing=jQuery.easing.swing,jQuery.extend(jQuery.easing,{def:"easeOutQuad",swing:function(a,b,c,d,e){return jQuery.easing[jQuery.easing.def](a,b,c,d,e)},easeInQuad:function(a,b,c,d,e){return d*(b/=e)*b+c},easeOutQuad:function(a,b,c,d,e){return-d*(b/=e)*(b-2)+c},easeInOutQuad:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b+c:-d/2*(--b*(b-2)-1)+c},easeInCubic:function(a,b,c,d,e){return d*(b/=e)*b*b+c},easeOutCubic:function(a,b,c,d,e){return d*((b=b/e-1)*b*b+1)+c},easeInOutCubic:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b+c:d/2*((b-=2)*b*b+2)+c},easeInQuart:function(a,b,c,d,e){return d*(b/=e)*b*b*b+c},easeOutQuart:function(a,b,c,d,e){return-d*((b=b/e-1)*b*b*b-1)+c},easeInOutQuart:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b*b+c:-d/2*((b-=2)*b*b*b-2)+c},easeInQuint:function(a,b,c,d,e){return d*(b/=e)*b*b*b*b+c},easeOutQuint:function(a,b,c,d,e){return d*((b=b/e-1)*b*b*b*b+1)+c},easeInOutQuint:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b*b*b+c:d/2*((b-=2)*b*b*b*b+2)+c},easeInSine:function(a,b,c,d,e){return-d*Math.cos(b/e*(Math.PI/2))+d+c},easeOutSine:function(a,b,c,d,e){return d*Math.sin(b/e*(Math.PI/2))+c},easeInOutSine:function(a,b,c,d,e){return-d/2*(Math.cos(Math.PI*b/e)-1)+c},easeInExpo:function(a,b,c,d,e){return 0==b?c:d*Math.pow(2,10*(b/e-1))+c},easeOutExpo:function(a,b,c,d,e){return b==e?c+d:d*(-Math.pow(2,-10*b/e)+1)+c},easeInOutExpo:function(a,b,c,d,e){return 0==b?c:b==e?c+d:(b/=e/2)<1?d/2*Math.pow(2,10*(b-1))+c:d/2*(-Math.pow(2,-10*--b)+2)+c},easeInCirc:function(a,b,c,d,e){return-d*(Math.sqrt(1-(b/=e)*b)-1)+c},easeOutCirc:function(a,b,c,d,e){return d*Math.sqrt(1-(b=b/e-1)*b)+c},easeInOutCirc:function(a,b,c,d,e){return(b/=e/2)<1?-d/2*(Math.sqrt(1-b*b)-1)+c:d/2*(Math.sqrt(1-(b-=2)*b)+1)+c},easeInElastic:function(a,b,c,d,e){var f=1.70158,g=0,h=d;if(0==b)return c;if(1==(b/=e))return c+d;if(g||(g=.3*e),h<Math.abs(d)){h=d;var f=g/4}else var f=g/(2*Math.PI)*Math.asin(d/h);return-(h*Math.pow(2,10*(b-=1))*Math.sin((b*e-f)*(2*Math.PI)/g))+c},easeOutElastic:function(a,b,c,d,e){var f=1.70158,g=0,h=d;if(0==b)return c;if(1==(b/=e))return c+d;if(g||(g=.3*e),h<Math.abs(d)){h=d;var f=g/4}else var f=g/(2*Math.PI)*Math.asin(d/h);return h*Math.pow(2,-10*b)*Math.sin((b*e-f)*(2*Math.PI)/g)+d+c},easeInOutElastic:function(a,b,c,d,e){var f=1.70158,g=0,h=d;if(0==b)return c;if(2==(b/=e/2))return c+d;if(g||(g=e*(.3*1.5)),h<Math.abs(d)){h=d;var f=g/4}else var f=g/(2*Math.PI)*Math.asin(d/h);return b<1?-.5*(h*Math.pow(2,10*(b-=1))*Math.sin((b*e-f)*(2*Math.PI)/g))+c:h*Math.pow(2,-10*(b-=1))*Math.sin((b*e-f)*(2*Math.PI)/g)*.5+d+c},easeInBack:function(a,b,c,d,e,f){return void 0==f&&(f=1.70158),d*(b/=e)*b*((f+1)*b-f)+c},easeOutBack:function(a,b,c,d,e,f){return void 0==f&&(f=1.70158),d*((b=b/e-1)*b*((f+1)*b+f)+1)+c},easeInOutBack:function(a,b,c,d,e,f){return void 0==f&&(f=1.70158),(b/=e/2)<1?d/2*(b*b*(((f*=1.525)+1)*b-f))+c:d/2*((b-=2)*b*(((f*=1.525)+1)*b+f)+2)+c},easeInBounce:function(a,b,c,d,e){return d-jQuery.easing.easeOutBounce(a,e-b,0,d,e)+c},easeOutBounce:function(a,b,c,d,e){return(b/=e)<1/2.75?d*(7.5625*b*b)+c:b<2/2.75?d*(7.5625*(b-=1.5/2.75)*b+.75)+c:b<2.5/2.75?d*(7.5625*(b-=2.25/2.75)*b+.9375)+c:d*(7.5625*(b-=2.625/2.75)*b+.984375)+c},easeInOutBounce:function(a,b,c,d,e){return b<e/2?.5*jQuery.easing.easeInBounce(a,2*b,0,d,e)+c:.5*jQuery.easing.easeOutBounce(a,2*b-e,0,d,e)+.5*d+c}});

// SCROLL
function GetscrollbarWidth () {
	var inner = document.createElement('p');
	inner.style.width = "100%";
	inner.style.height = "200px";

	var outer = document.createElement('div');
	outer.style.position = "absolute";
	outer.style.top = "0px";
	outer.style.left = "0px";
	outer.style.visibility = "hidden";
	outer.style.width = "200px";
	outer.style.height = "150px";
	outer.style.overflow = "hidden";
	outer.appendChild (inner);

	document.body.appendChild (outer);
	var w1 = inner.offsetWidth;
	outer.style.overflow = 'scroll';
	var w2 = inner.offsetWidth;
	if (w1 == w2) w2 = outer.clientWidth;

	document.body.removeChild (outer);

	return (w1 - w2);
};